import { combineEpics, type Epic } from 'redux-observable';
import { filter } from 'rxjs';
import { request } from '@/core';
import { updateMemberRequest } from '@/api/members';
import { updateMember } from '../actions';

const updateMemberEpic: Epic = (action$) =>
  action$.pipe(
    filter(updateMember.match),
    request(({ payload }) => updateMemberRequest(payload), updateMember),
  );

export default combineEpics(updateMemberEpic);
